import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import styled from "@mui/material/styles/styled";
import { layoutConstant } from "src/lib/utils/constants";

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 8,
  padding: "20px",
  overflow: "hidden",
  position: "relative",
  display: "flex",
  border: `1px solid ${theme.palette.light.light2}`,
}));

export const MobileStyledBox = styled(Box)(({ theme }) => ({
  alignItems: "flex-end",
  position: "fixed",
  padding: 16,
  left: 0,
  right: 0,
  bottom: layoutConstant.mobileHeaderHeight,
  zIndex: theme.zIndex.drawer - 1,
  backgroundColor: "#fff",
  borderTop: `1px solid ${theme.palette.light.light2}`,
  borderBottom: `1px solid ${theme.palette.light.light2}`,
}));
